<template>
  <v-dialog
    v-model="isOpen"
    :fullscreen="$vuetify.breakpoint.mobile"
    persistent
    scrollable
    width="500"
  >
    <v-card>
      <v-card-title class="font-weight-light">
        Create New Batch
        <v-spacer></v-spacer>
        <v-btn
          color="red lighten-5 red--text"
          depressed
          rounded
          small
          @click="close_dialog"
          >Close
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>Add a new inventory batch</v-card-subtitle>
      <v-card-text>
        <v-form ref="create_batch_form">
          <v-row dense>
            <v-col cols="12" class="mt-5">
              <v-autocomplete
                color="orange"
                v-if="!selected_item_id"
                outlined
                :items="batch_items"
                item-value="id"
                item-text="name"
                v-model="item_id"
                :loading="items_loading"
                no-data-text="No items found"
                :return-object="false"
                label="Select Item"
                :rules="$store.state.requiredRule"
                persistent-hint
                width="100%"
                @change="on_item_change"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-avatar rounded="lg" size="60">
                    <v-img :src="item.photo"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-black">{{
                      item.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >Price:{{
                        item.selling_price | toMoney | currency_symbol
                      }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      >QTY:{{ item.quantity }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      >Type:{{ item.type }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-text-field
                color="orange"
                label="Batch Number"
                v-model="batch_number"
                :rules="$store.state.requiredRule"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="is_expiry_item">
              <v-menu
                ref="menu"
                v-model="date_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    color="orange"
                    v-model="expiry_date"
                    label="Expiry Date"
                    readonly
                    v-bind="attrs"
                    :rules="$store.state.requiredRule"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="expiry_date"
                  @input="date_menu = false"
                  no-title
                  scrollable
                  color="orange"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          color="orange"
          dark
          :loading="creating_batch"
          depressed
          x-large
          rounded
          @click="create_batch"
          >Create Batch
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    createDialogOpen: {
      type: Boolean,
      default: false,
    },
    selected_item_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      batch_number: "",
      expiry_date: null,
      date_menu: false,
      batch_items: [],
      item_id: null,
      items_loading: false,
      creating_batch: false,
    };
  },
  watch: {
    createDialogOpen(val) {
      this.isOpen = val;
    },
    selected_item_id: {
      handler() {
        this.item_id = this.selected_item_id;
      },
      immediate: true,
    },
  },
  computed: {
    is_expiry_item() {
      const item = this.batch_items.find((item) => item.id === this.item_id);
      return item && item.expires;
    },
  },
  methods: {
    close_dialog() {
      this.$emit("create_closed");
      if (!this.selected_item_id) {
        this.clear_form();
      }
    },
    clear_form() {
      this.batch_number = "";
      this.expiry_date = null;
      this.date_menu = false;
      this.item_id = null;
      this.items_loading = false;
      this.creating_batch = false;
    },
    on_item_change() {
      const selected_item = this.batch_items.find(
        (item) => item.id === this.item_id
      );
    },
    create_batch() {
      if (this.$refs.create_batch_form.validate()) {
        this.creating_batch = true;
        const form_data = new FormData();
        form_data.append("item_id", this.item_id);
        form_data.append("batch_number", this.batch_number);
        if (this.is_expiry_item) {
          form_data.append("expiry_date", this.expiry_date);
        }
        axios
          .post("/api/item-batches", form_data)
          .then((res) => {
            this.$emit("create_completed");
          })
          .catch((error) => {})
          .finally(() => {
            this.creating_batch = false;
          });
      }
    },
    get_products() {
      this.items_loading = true;

      axios
        .get("/api/batched-items")
        .then((res) => {
          this.batch_items = res.data;
        })
        .finally(() => {
          this.items_loading = false;
        });
    },
  },
  mounted() {
    this.get_products();
  },
};
</script>
